import { LanguageCode } from './types';

export type LocaleType = LanguageCode;

export const SUPPORTED_LOCALE_RESOURCE_CODES = [
  LanguageCode.zh,
  LanguageCode.en,
  LanguageCode.pt,
  LanguageCode.ja,
  LanguageCode.de,
  LanguageCode.es,
  LanguageCode.kor,
  LanguageCode.th,
] as const;

export type LocaleResourceCode = typeof SUPPORTED_LOCALE_RESOURCE_CODES[number];

/**
 * 将业务语言码收敛到实际存在的语言包文件名，未支持语言统一使用英文资源。
 */
export function getLocaleResourceCode(languageCode: string): LocaleResourceCode {
  const normalizedCode = (languageCode || '').toLowerCase();

  if (normalizedCode === LanguageCode.zhHans.toLowerCase()) return LanguageCode.zh;
  if (normalizedCode === LanguageCode.zhHant.toLowerCase()) return LanguageCode.en;
  if (normalizedCode === 'ko') return LanguageCode.kor;

  return SUPPORTED_LOCALE_RESOURCE_CODES.find(
    (code) => code.toLowerCase() === normalizedCode,
  ) || LanguageCode.en;
}

// export function getFankuiLocale(locale: LocaleType) {
//   const fankuiLangMap: Record<LocaleType, string> = {
//     zh: 'zh-Hans',
//     en: 'en',
//   };
//   return fankuiLangMap[locale] || 'zh-Hans';
// }

// export function getAccountLocale(locale: LocaleType) {
//   const accountLangMap: Record<LocaleType, string> = {
//     zh: 'zh-Hans',
//     en: 'en',
//   };
//   return accountLangMap[locale] || 'zh-Hans';
// }

// export function getLocaleFromNavigator(navigator: Navigator): LocaleType {
//   const languageMap: Record<string, LocaleType> = {
//     zh: 'zh', // 中文
//     'zh-cn': 'zh', // 中文简体（中国大陆）
//     en: 'en', // 英美
//   };
//   return languageMap[navigator.language.toLowerCase()] || 'en';
// }

// export type SubscriptionLang = 'zh-CN' | 'en';
// export function getSubscriptionLang(locale: LocaleType) {
//   const map: Record<LocaleType, SubscriptionLang> = {
//     zh: 'zh-CN',
//     en: 'en',
//   };
//   return map[locale] || '';
// }

// export function getClientLocale(locale: LocaleType) {
//   const accountLangMap: Record<LocaleType, string> = {
//     zh: 'zh-Hans',
//     en: 'en',
//   };
//   return accountLangMap[locale] || 'zh-Hans';
// }
